import Vue from './vue-config'

if (document.getElementById('search')) {
    new Vue({
        el: '#search',
        data: {
            query: '',
            results: [],
            searched: false,
            page: 0,
            perPage: 18,
            filter: ''
        },
        methods: {
            keydown(e) {
                if (e.keyCode != 13) this.searched = false
            },
            doSearch() {
                var vm = this
                vm.searched = true
                vm.doPost('/umbraco/surface/search/search', { query: vm.query }, (data) => {
                    vm.results = data
                })
            },
            setPage(p) {
                this.page = p
                window.scrollTo({
                    top: this.scrollTop,
                    behavior: 'smooth'
                })
            },
            setFilter(f) {
                this.filter = f
            }
        },
        computed: {
            pages() {
                return Math.ceil(this.filtered.length / this.perPage)
            },
            filtered() {
                return this.results.filter(r => this.filter == '' || r.Type == this.filter)
            },
            displayPage() {
                return this.page + 1
            },
            curPage() {
                return this.filtered.slice(this.page * this.perPage, (this.page * this.perPage) + this.perPage)
            },
            noResults() {
                return this.searched && this.query.length >= 3
                    && this.results.length == 0
            },
            types() {
                return this.results.map(r => r.Type).filter((v, i, a) => a.indexOf(v) == i && v != '')
            }
        },
        mounted() {
            var vm = this
            vm.scrollTop = vm.$el.querySelector('.search-results').offsetTop - 30
            if (vm.querystringObject.query) vm.query = vm.querystringObject.query
            vm.doSearch()
        }
    })
}